"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersProvider = exports.OrdersContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ApiOrderRepo_1 = require("../../../modules/orders/infra/ApiOrderRepo");
exports.OrdersContext = react_1.default.createContext(null);
const OrdersProvider = ({ children, }) => {
    const ordersRepo = (0, ApiOrderRepo_1.createApiOrderRepo)();
    const value = {
        getAll: (page, pageSize, filter, machineIds, clubIds, startDate, endDate, sort) => ordersRepo.getAll(page, pageSize, filter, machineIds, clubIds, startDate, endDate, sort),
        getById: (id) => ordersRepo.getById(id),
        getSummary: (filter, startDate, endDate, machineIds, clubIds) => ordersRepo.getSummary(filter, startDate, endDate, machineIds, clubIds),
        checkOrders: (startTs, endTs) => ordersRepo.checkOrders(startTs, endTs),
    };
    return ((0, jsx_runtime_1.jsx)(exports.OrdersContext.Provider, { value: value, children: children }));
};
exports.OrdersProvider = OrdersProvider;
